import { Location } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';
import type { IRoute } from '..';

const OperationalSituationPage = lazy(() => import('@cobliteam/operational-situation'));

const routes: IRoute[] = [
  {
    path: Location.OPERATIONAL_SITUATION,
    component: OperationalSituationPage,
    exact: true,
  },
];

export default routes;
